import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { WindowRefService } from '../services/window-ref.service';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[featureToggle]'
})


// This feature toggle directive helps us enable features on and off through util.js

export class FeatureToggleDirective implements OnInit {

    @Input() featureToggle: string;
    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private windowRefService: WindowRefService
    ) { }

    ngOnInit(): void {
        if (this.isEnabled()) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }

    isEnabled() {
        return this.windowRefService.nativeWindow[this.featureToggle];
    }

}
